import VideoHelpers from "./video_helpers";
import locale from "../shared/locale";

export default function i18n(text) {
  try {
    if (window['active_language'] === undefined) {
      window['active_language'] = VideoHelpers.getLang();
    }

    return text.split('.')
      .reduce((o, i) => {
        if (!o[i]) throw new Error();
        return o[i];
      }, locale[window['active_language']])
  } catch (err) {
    console.warn(err)
    return text
  }
}
